import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiCard from '@mui/material/Card';
import MuiCardActions from '@mui/material/CardActions';
import MuiCardContent from '@mui/material/CardContent';
import MuiCardHeader from '@mui/material/CardHeader';
import { wrap } from '../wrap';

export const Card = wrap(MuiCard, 'Card', { emphasis: 'surface' });
export const CardContent = wrap(MuiCardContent, 'CardContent');
export const CardHeader = wrap(MuiCardHeader, 'CardHeader');
export const CardActions = wrap(MuiCardActions, 'CardActions');

export const Accordion = wrap(MuiAccordion, 'Accordion');
export const AccordionSummary = wrap(MuiAccordionSummary, 'AccordionSummary');
export const AccordionDetails = wrap(MuiAccordionDetails, 'AccordionDetails');
